<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Coupon Logs",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Coupon Logs",
            items: [
               {
                  text: "Coupons",
                  href: "/coupons",
               },  
               {
                  text: "Logs",
                  active: true,
               },                   
            ],

            logs: [],  
            coupon: {},

            from: null,
            to: null,
            total: null,
            pagination: {},
            
            keyword: "",
            showsearch: false,
            listing_length: 10,
            token: "",
            errors: {},          
            active_page_url: null,
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchLogs();
      },

      methods: {
         fetchLogs() {

            this.getToken();
            let url = "api/admin/coupon/logs?coupon_id="+ this.$route.params.id;


            this.loading = true;
            
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.coupon = responseData.coupons;
                  this.logs = responseData.orders;
             
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'coupons' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <div class="row">
                     <div class="col-12">
                        <h6>Coupon: {{coupon.coupon_code}}</h6>
                     </div>
                  </div>

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Name</th>   
                              <th v-if="coupon.coupon_for==2 || coupon.coupon_for==3">Booking</th>
                              <th v-if="coupon.coupon_for==1">Order</th>
                              <th>Amount</th>
                              <th>Created on</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(logs.length)">
                           <tr v-for="(log) in logs" :key="log.id">
                              <td>{{log.name}}</td>
                              <td v-if="coupon.coupon_for==2 || coupon.coupon_for==3">
                                 Booking ID: {{log.booking_id}}<br>               
                                 {{log.booking_date | formatDate }}<br>
                                 {{log.consultation_start | formatTime}} - {{log.consultation_end | formatTime}}
                              </td>
                              <td v-if="coupon.coupon_for==1">
                                 Order ID: {{log.order_id}}
                              </td>
                              <td>
                                 Rs. <span v-if="coupon.coupon_for==1">{{log.price}}</span>
                                 <span v-if="coupon.coupon_for==2 || coupon.coupon_for==3">{{log.total_amount}}</span>
                              </td>
                              <td>{{log.created_at | formatDateTime}}</td>
                             
                              <td>
                                 <router-link v-if="coupon.coupon_for==2 || coupon.coupon_for==3" :to="{ name: 'consultations.details', params: {id: log.booking_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Consultation Details</router-link> 

                                 <router-link v-if="coupon.coupon_for==1" :to="{ name: 'pharmacy.orders.details', params: {id: log.order_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Order Details</router-link>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No logs found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
